import { useMutation, useQueryClient } from 'react-query'

import { api } from '../../../api'
import { type ExpertDomain } from '../../../../types/domain/expert-domain'

export type UpdateExpertInternationalParams = {
  name: string
  email: string
  phone: string
  linkedin?: string
  city: string
  state: string
  country: string
  bankData?: {
    swiftCode?: string
    bankAccountNumber?: string
    internationalBankBranch?: string
    amazonGiftCardEmail?: string
  }
}

const updateExpertInternationalData = async (
  id: number,
  data: UpdateExpertInternationalParams
): Promise<ExpertDomain> => {
  const response = await api.put<ExpertDomain>(
    `/experts/${id}/international-data`,
    data
  )
  return response.data
}

export const useExpertInternationalDataMutation = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn ({
      id,
      data,
    }: {
      id: number
      data: UpdateExpertInternationalParams
    }) {
      return updateExpertInternationalData(id, data)
    },
    onSuccess (data) {
      queryClient.invalidateQueries(['expert', data.id])
    },
  })
}
